import { Component, EventEmitter, Input, OnDestroy, Output, Renderer2, ViewChild } from '@angular/core';
import { AgGridService } from '../ag-grid/ag-grid.service';
import { StorageService } from '../../services/storage.service';
import { CommonService } from '../../services/common.service';
import { Subscription } from 'rxjs';
import { ItemListDesignNoColumn, ItemListGoldPurityWtColumn, ItemListGrossWtColumn, ItemSectionModel, agGridDataModelItemList } from "./item-list-section.model"
import { StorageName } from '../../enum/common-enum';
import { Router } from '@angular/router';
import { VoucherType, VoucherTypeName } from '../../models/common.model';
import { AgColDefsI, AgGridI } from '../ag-grid/ag-grid.model';
import { ItemListCheckboxColumn ,ItemListImageColumn,ItemListBarcodeNoColumn,ItemListDescriptionColumn,ItemListFinalWtColumn,ItemListMakingColumn,ItemListTaxColumn,ItemListAmtColumn,ItemListNetAmtColumn,ItemListActionColumn} from './item-list-section.model'
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ItemListSectionService} from './item-list-section.service'
import { NotificationService } from '../../services/notification.service';
import { ExcelConverterServiceService } from '../../services/excel-converter-service.service';
import { StockJournal2Service } from '../../../components/transaction/stock-journal2/stock-journal2.service';
import { MastersService } from '../../../components/administration/masters/masters.service';
@Component({
  selector: 'app-item-list-section',
  templateUrl: './item-list-section.component.html',
  styleUrls: ['./item-list-section.component.scss']
})
export class ItemListSectionComponent extends  CommonService implements OnDestroy {
  @Output() onItemListChange: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteItemClick: EventEmitter<any> = new EventEmitter();
  @Output() onItemListRowClick: EventEmitter<any> = new EventEmitter();
  @Input() formName:string;
  @Input() formModel : any = {};
  @Input() ImportButtonVisibility:boolean = false
  @Input() gridDynamicHeightClass : string = 'h-250px';
  @Input() SampleFileData:any
  @Input() title ='Print';
  @Output() onPrint = new EventEmitter();
  agGridDataModelItemList : any
  gridApi:any;
  onAddProductsInItemListSubscription: Subscription;
  getInvoiceSubscription: Subscription;
  resetInvoiceSubscription: Subscription;
  tabId:number;
  @Input() itemSectionModel = new ItemSectionModel()
  @Output() grossWeightCalculated = new EventEmitter<number>();
  showImportAndDownloadFile:boolean = false;
  showImportAndSampleFile:boolean = false;
  @Output() barcodeNo = new EventEmitter();
  storageName = StorageName
  fileName ="";
  Filepath:any;
  selectedFile: File | null = null;
  sampleFileData:any;
  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  constructor(
    public notificationService : NotificationService,
    public agGridService : AgGridService,
    public renderer: Renderer2,
    public modalService: NgbModal,
    public storageService : StorageService,
    public router : Router,
    public itemListSectionService : ItemListSectionService,
    public excelConverterServiceService : ExcelConverterServiceService,
    public stockJournal2Service : StockJournal2Service,
    public mastersService : MastersService,
    
    ){
     super(renderer);;
      this.onAddProductsInItemListSubscription = this.storageService?.onAddProductsInItemList?.subscribe((result) => {
        if(result != undefined)
        this.onAddProductsInItemListResponce(result);
       });
       this.getInvoiceSubscription = this.storageService?.getInvoice?.subscribe((result) => {
        if(result != undefined)
        this.getInvoiceResponse(result?.response);
       });
       this.resetInvoiceSubscription = this.storageService?.resetInvoice?.subscribe((result) => {
        if(result != undefined)
          this.resetInvoiceResponse(result);
          this.addFooterAndCalculation(this.gridApi);
       });
  }
  onDeleteIconClick(params) {
    if( this.formName == VoucherTypeName?.StockJournalOption2 || this.formName == VoucherTypeName.StockTransferOut || this.formName == VoucherTypeName.StockTransferIn)
    {
      this.onDeleteItemClick.emit(params.detail.data); 
    }
    else
    {
    const result = params?.detail?.data;
    this.onDeleteRowClickedResponse(result);
    this.formModel.invoiceDocumentResources = this.formModel.invoiceDocumentResources.filter((x) => {
    return x.designNo != result.data.designNo;
    });
    }
  }

  onDeleteRowClickedResponse(event) {
    this.itemListChange()
  }
  ngOnInit() {
    this.agGridDataModelItemList = agGridDataModelItemList;
    this.itemSectionModel.setVisibility(); // Assuming formName is the StorageName
    this.getSampleFileByPageName();
  }

  ngAfterViewInit(): void {
    this.setStorageNames();
  }

  setColumnsVisible(columnNames: string[], visible: boolean) {
    setTimeout(() => {
      columnNames.forEach(name => {
        this.gridApi?.columnApi?.setColumnVisible(name, visible);
      });
      if (!visible && this.itemSectionModel?.hideColumnConditionally) {
        this.storageService.hideColumnsPermanent.next({
          columnName: columnNames,
          storageName: this.gridApi?.storageName?.toString()
        });
      }
    }, 700);
  }
  

  setStorageNames()
  {
    this.agGridDataModelItemList.storageName =this.itemSectionModel.storageName;
  }

  resetInvoiceResponse(formName) {
    if(formName != undefined) {
      this.gridApi?.api?.setRowData([]);
      this.formModel = {};
      this.formModel.invoiceModel = {};
    }
  }

  getInvoiceResponse(result) {
    this.formModel.itemList = result?.itemList?.filter(a=>a?.consumptionOrProductionId != 1);
    this.gridApi?.api?.setRowData(this.formModel?.itemList);
    this.formModel.grossWt = this.calculateTotalGrossWt(this.formModel?.itemList);
    this.grossWeightCalculated?.emit(this.formModel?.grossWt);
  }
  
  calculateTotalGrossWt(itemList) {
    const sumOfGrossWt = (itemList?.map(a => Number(a?.grossWt))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(2);
    return sumOfGrossWt;
  }

  onAddProductsInItemListResponce(res) {
    if (res?.isSuccess) {
      var data = this.gridApi?.api?.getSelectedRows();
      var dataNodes = this.gridApi?.api?.getSelectedNodes();
      if (this.formModel?.invoiceModel?.fromScrapInvoiceItem == true)
        res.response.againstVoucherTypeId = VoucherType.OldJewelryScrapInvoice;
      if (data != undefined && data?.length > 0) {
        var response = res?.response;
        this.updateColumnsInSelectedRows(response, data);
       }
      else {
        if (Array.isArray(res?.response)) {
          this.agGridService.addNewRowsWithData(this.gridApi, res?.response);
        } else {
          this.agGridService.addNewRowWithData(this.gridApi, res?.response);
        }
       }
      this.itemListChange();
    } else this.notificationService.errorPopup(res.errors[0]);
  }

  calculateTotal(property: string, data: any[]): number {
    return data?.map(item => Number(item[property])).filter(value => !isNaN(value)).reduce((a, b) => a + b, 0) || 0;
  }

  itemListChange() {
    this.formModel.itemList = this.gridApi.api.getModel().rowsToDisplay.map(a => a.data);
    this.onItemListChange.emit(this.formModel);
    this.formModel.grossWt = this.calculateTotalGrossWt(this.formModel.itemList);
    this.grossWeightCalculated.emit(this.formModel.grossWt);
    this.addFooterAndCalculation(this.gridApi);
  }

  updateColumnsInSelectedRows(response, selectedRows) {
    selectedRows.forEach(row => {
      row.detailedJson = response.detailedJson;
      row.netAmount = response.netAmount;
      row.quantity = response.quantity;
      row.amount = response.amount;
      row.designNo = response.designNo;
      row.barcodeNo = response.barcodeNo;
      row.metalValue = response.metalValue;
      row.taxAmount = response.taxAmount;
      row.makingAmount = response.makingAmount;
      row.netAmountWithTax = response.netAmountWithTax;
      row.goldPurityWt = response.goldPurityWt;
      row.grossWt = response.grossWt;
      row.finalWt = response.finalWt;
      row.alloyWt = response.alloyWt;
      row.quantity = response.quantity;
      row.edited = true;
      row.added = true;
      row.deleted = false;
      row.parentMetalId = response.parentMetalId;
      row.description = response.description;
      row.comment = response.comment;
      row.groupName = response.groupName;
    });
    try {
      setTimeout(() => {
        this.gridApi.api.redrawRows();
        this.gridApi.api.refreshCells();
        this.gridApi.api.deselectAll();
      }, 600);
    }
    catch (ex) {
    }
  }

  onGridReady(gridApi) {
    this.gridApi = gridApi;
    const stockJournalOption2Data = this.storageService.retrieve( StorageName.STORED_STOCKJOURNAL_OPTION2_DATA);
    this.setColumnsVisible(["designNo"], this.itemSectionModel?.showDesignNoColumn);
    this.setColumnsVisible(["active"],this.formModel.voucherType === VoucherTypeName.StockTransferIn? true: (stockJournalOption2Data?.isUpdateOldItemsForStockJournal ?? false));
    this.setColumnsVisible(["barcodeNo", "grossWt", "finalWt", "makingAmount", "taxAmount", "netAmount"], this.itemSectionModel?.hideColumnConditionally);
  }

  onEditIconClick(event){
    this.onItemListRowClick.emit(event); 
  }

  imgCellClicked(event){
    this.gridApi.api.deselectAll();
    event.node.setSelected(true);
    this.storageService.imgCellClicked.next(event);
  }



  confirmPrintPopUp(event) {
    const title = `${this.title} ${(this.formName === this.storageName.FORMNAME_TRANSACTION_STOCKJOURNAL || 
                    this.formName === this.storageName.FORMNAME_INVENTORY_BARCODE) ? 'barcode' : 'bill'}`;
    const message = `Do you want to ${this.title.toLowerCase()} ${(this.formName === this.storageName.FORMNAME_TRANSACTION_STOCKJOURNAL || 
                    this.formName === this.storageName.FORMNAME_INVENTORY_BARCODE) ? 'barcode' : 'invoice'}?`;
    this.notificationService.confirmationPopup(title, message, 'printBill').subscribe((result) => {
      if(result.isConfirmed) {
        this.onPrint.emit(true);
      }else{
        this.onPrint.emit(false);
      }
    });
  }

  getBarcode(event){
    const node  =  event?.node;
    this.itemListSectionService.GenerateBarcodeForSaleOrderItem().subscribe((res) => {
      if (res.isSuccess) {
        const value = res?.response;
        node.setDataValue('barcodeNo', value);
      }
    })

  }
 
 callApionRowCellClicked(event){
    if(this.formName == StorageName.FORMNAME_TRANSACTION_JOBWORKINVOICE){
      this.storageService.onItemListRowClicked.next(event);
    }
  }
  hasImageRendererClass(target: any): boolean {
    return target?.closest('.images_renderer') !== null;
  }
  hasClassInTarget(target: any, className: string): boolean {
    return target?.closest(`.${className}`) !== null;
  }
  onFileSelect(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      
    }
  }

  downloadExcel() {
    this.exportExcel(this.SampleFileData?.headerNames, [], `${this.SampleFileData.fileName}.xlsx`);
  }

  handleError(arg0: any): any {
    throw new Error('Method not implemented.');
  }


   //#region footer row calculation
  addFooterAndCalculation(params) {
    const rowsdata = params?.api?.getModel()?.rowsToDisplay?.map(a => a?.data);
    const sumOfMakingAmt = (rowsdata?.map(a => Number(a?.makingAmount))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0);
    const sumOfGrossWt = (rowsdata?.map(a => Number(a?.grossWt))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfGoldPurityWt: string = (rowsdata?.map(a => Number(a?.goldPurityWt))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfFinalWt: string = (rowsdata?.map(a => Number(a?.finalWt))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfTaxAmount: string = (rowsdata?.map(a => Number(a?.taxAmount))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfAmount: string = (rowsdata?.map(a => Number(a?.amount))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfNetAmount: string = (rowsdata?.map(a => Number(a?.netAmount))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfQuantity: string = (rowsdata?.map(a => Number(a?.quantity))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfNetAmountWithTax: string = (rowsdata?.map(a => Number(a?.netAmountWithTax))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const sumOfstoneChargeAmount:string = (rowsdata?.map(a => Number(a?.stoneChargeAmount))?.filter(value => typeof value === 'number' && !isNaN(value))?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0).toFixed(3);
    const totalsObject = {
      makingAmount: sumOfMakingAmt,
      grossWt: sumOfGrossWt,
      goldPurityWt: sumOfGoldPurityWt,
      finalWt: sumOfFinalWt,
      taxAmount: sumOfTaxAmount,
      amount: sumOfAmount,
      netAmount: sumOfNetAmount,
      quantity: sumOfQuantity,
      netAmountWithTax: sumOfNetAmountWithTax,
      stoneChargeAmount:sumOfstoneChargeAmount,
      isFooterRow: true
    }
    params?.api?.setPinnedBottomRowData([totalsObject]);
    params?.api?.refreshCells();

  }
  //#endregion

// #download import samplefile startregion //
getSampleFileByPageName(){
  const requestData = {pageName:this.formName}
   this.mastersService.getsamplefilebypagename(requestData).subscribe({
     next:(res)=>{
       if(res?.isSuccess){
           this.SampleFileData = res?.response;
       }
     },error:(err)=>{
      
     }
   })
 }

  onFileSelected(event: any) {
     const file = event.target.files?.[0];
     if (file) {
       event.target.value = "";
       this.selectedFile = file;
       this.fileName = file.name;
     }    
  }  

  onClickSampleFile() {
    const tabId = this.storageService.retrieve('ActiveId');
    var  matchedItems =  this.SampleFileData?.find(data => data.integrationWith === tabId);
    if (matchedItems) {
      this.Filepath = matchedItems?.filePath;
      if (this.Filepath) {
        this.excelConverterServiceService?.downloadXlsx(this.Filepath);
      } else {
        console.error('No matching file found');
      }
    } else {
      console.error('Invalid tab ID or no matching data found');
    }
  }

  toggleDropdown() {
    if (this.dropdown.isOpen()) {
      this.dropdown.close();
    } else {
      this.dropdown.open();
    }
  }

// #region For Import File
  uploadFile() {
    if (this.selectedFile) {
      const file = this.selectedFile;
      const tabId = this.storageService.retrieve('ActiveId');
      const formData = new FormData();
      formData.append('file', file);
      formData.append('metalId', tabId.toString()); // Ensure tabId is parsed to string
      this.stockJournal2Service.uploadFile(formData, tabId).subscribe({
        next: (res) => {
          if (res?.isSuccess) {
            this.storageService.store(StorageName.PRODUCT_DROPDOWN, res?.response?.productDropdown)
            this.storageService.store(StorageName.CARAT_DROPDOWN, res?.response?.caratDropdown)
            this.storageService.store(StorageName.CATEGORY_DROPDOWN, res?.response?.categoryDropdown )
            this.agGridService.addNewRowsWithData(this.gridApi,res?.response.data);
            this.itemListChange();
            this.toaster?.success(res?.message);
            this.clearFiles();
          }
        },
        error: (err) => {
          
        }
      });
    }
    else{
      this.toaster.error('Please select File');
    }
  }
// #endregion For Import File

  clearFiles(){
    this.fileName ="";
    this.Filepath =undefined;
    this.selectedFile =undefined;
  }
  // #download import samplefile endregion //
  ngOnDestroy(): void {
    this.onAddProductsInItemListSubscription?.unsubscribe()
    this.getInvoiceSubscription?.unsubscribe()
    this.resetInvoiceSubscription?.unsubscribe()
  }
}
